import { Block, TableBlock } from "./types";

export const smoothCenterBlock = (
  scrollRef: HTMLElement,
  blockTop: number,
  blockHeight: number,
) => {
  scrollRef.style.scrollBehavior = "smooth";
  // if the block itself is taller than the viewport, scroll to the top
  if (blockHeight > scrollRef.clientHeight) {
    scrollRef.scrollTop = blockTop;
    return;
  }
  const padding = (scrollRef.clientHeight - blockHeight) / 2;
  // if the block is near the start of the viewport, scroll to top
  if (blockTop < padding) {
    scrollRef.scrollTop = 0;
    return;
  }
  // if the block is near the end of the viewport, scroll to bottom
  if (blockTop > scrollRef.scrollHeight - padding - blockHeight) {
    scrollRef.scrollTop = scrollRef.scrollHeight - scrollRef.clientHeight;
    return;
  }
  // otherwise scroll the element into the centre
  scrollRef.scrollTop = blockTop - padding;
};

export const blockIsTable = (block: Block): block is TableBlock =>
  "cells" in block && Array.isArray(block.cells);
